import React from 'react';
import cn from 'bem-cn';

import { Icon } from '../Icon';
import { Stack } from '../Stack/Stack';

import { InfoBlockProps } from './InfoBlock.types';
import './InfoBlock.scss';

const b = cn('info-block');

export const InfoBlock: React.FC<InfoBlockProps> = ({ text, isError, icon, showArrow = false, isWarning }) => {
    return (
        <Stack className={b({ error: isError, warn: isWarning })} spacing={8} direction="row" alignItems="center">
            <Icon className={b('icon')} name={icon || 'info'} size={24} />
            <span dangerouslySetInnerHTML={{ __html: text }} />
            {showArrow && <Icon name="chevronRight" size={16} className={b('arrow')} />}
        </Stack>
    );
};
